import m from 'mithril'

class Debugger {
  constructor() {
    this.logCoordinates = this._logCoordinates.bind(this)
  }

  oninit(vnode) {
    let state = this
    state.viewer = vnode.attrs.viewer
  }

  _logCoordinates() {
    let state = this
    let fov = state.viewer.view().fov()
    let yaw = state.viewer.view().yaw()
    let pitch = state.viewer.view().pitch()

    console.log(`FOV: ${fov}, Yaw: ${yaw}, Pitch: ${pitch}`)
  }

  view(vnode) {
    let state = this
    return (
      <div class="debugger-target">
        <div class="debugger-center" onclick={state.logCoordinates}>
          +
        </div>
      </div>
    )
  }
}

export default Debugger
